import React, { Component } from 'react';
import { Navbar, Nav, NavItem, RouteNavItem, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AwesomeButton } from 'react-awesome-button';

import './MyNavbarButtons.css';

export default class MyNavbarButtons extends Component {
  render() {
    return (
      <Navbar default collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link className="navbar-home-link" to="/">Christopher DiNome</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            <NavItem eventKey={1} componentClass={Link} className="navbar-link" href="/" to="/">
              <AwesomeButton>About Me</AwesomeButton>
            </NavItem>
            <NavItem eventKey={2} componentClass={Link} className="navbar-link" href="/projects" to="/projects">
              <AwesomeButton>Projects</AwesomeButton>
            </NavItem>
            <NavItem eventKey={3} componentClass={Link} className="navbar-link" href="/resume" to="/resume">
              <AwesomeButton>Resume</AwesomeButton>
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MyNavbarButtons.jsx